import Moment from 'moment';
import i18n from '@/locales';

const dateFormatFilter = (unix, type, forceUTC) => {
  if (Number.isInteger(unix)) {
    let unixMoment = Moment.unix(unix).locale(i18n.locale);

    if (forceUTC) unixMoment = unixMoment.tz('UTC');

    switch (type) {
      case 'calendar':
        return unixMoment.calendar();
      case 'fromNow':
      case 'relative':
        return unixMoment.fromNow();
      case 'toNow':
        return unixMoment.toNow();
      case 'days':
        return unixMoment.diff(Moment(), 'days');
      case 'short':
        return unixMoment.format('l');
      case 'medium':
        return unixMoment.format('ll');
      case 'long':
        return unixMoment.format('LL');
      case 'timestamp':
        return unixMoment.format('lll');
      case 'date-field':
        return unixMoment.format('YYYY-MM-DD');
      case 'time':
        return unixMoment.format('h a');
      case 'timestamp_with_timezone':
        const date = unixMoment.toDate(); // eslint-disable-line no-case-declarations
        const options = { // eslint-disable-line no-case-declarations
          weekday: 'short',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZoneName: 'short',
        };

        if (forceUTC) options.timeZone = 'UTC';
        return date.toLocaleString(i18n.locale, options);
      case 'timezone':
        return Moment().tz(Moment.tz.guess()).format('z');
      default:
        return '-';
    }
  } else if (unix) {
    return 'Invalid Timestamp';
  } else {
    return '';
  }
};

export default dateFormatFilter;
